module.exports = __webpack_public_path__ + "img/topazinho-2.4a6b791f.png";